import React from 'react'
import { navigationItems } from '../config'
import MenuTreeParser from '../utils/menu_tree_parser'

const Breadcrumb = (props) => {
  const { location, navigate } = props

  let currentBasePath = '/'
  const arr = location.pathname.split('/').filter((item) => item !== '')
  if (arr.length) {
    currentBasePath = '/' + arr[0]
  }

  const menuTree = MenuTreeParser.parse(navigationItems, currentBasePath, [])
  let pages = null
  if (menuTree) {
    pages = menuTree.map((item) => {
      return { title: item.title, path: item.path }
    })
  }

  return (
    <div className='white-bg' style={{ marginTop: 0, paddingTop: 0 }}>
      <ol className='breadcrumb'>
        <li onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          Home
        </li>
        {pages &&
          pages.length &&
          pages.map((item, i) => {
            if (i === pages.length - 1) {
              return (
                <li className='active' key={i}>
                  <strong>{item.title}</strong>
                </li>
              )
            }
            return (
              <li
                className='cursor-pointer'
                onClick={() => {
                  if (item.path === '/' && window.location.search.indexOf('index=') !== -1) {
                    navigate(item.path + window.location.search)
                  } else {
                    navigate(item.path)
                  }
                }}
                key={i}
              >
                {item.title}
              </li>
            )
          })}
      </ol>
    </div>
  )
}

export default Breadcrumb
